import * as z from "zod/v4";

export const createStripeConnectedAccount = {
  name: "createStripeConnectedAccount" as const,
  input: z.any(),
  output: z.object({ connectedAccountId: z.string() }),
};
